/**
 * Sprint 8.5 F2.1+F2.2 — wrapper de fetch que adjunta el JWT de Supabase.
 *
 * Antes el frontend llamaba a `/api/*` sin Authorization header → el backend
 * confiaba en `userId` del body/query (IDOR universal).
 *
 * Ahora todas las llamadas a backend van por `apiFetch` que adjunta el
 * `access_token` de la sesión Supabase. El backend valida con `requireAuth`.
 */

import { supabase } from './supabase'

async function getToken() {
  const { data } = await supabase.auth.getSession()
  return data?.session?.access_token || null
}

export async function apiFetch(input, init = {}) {
  const token = await getToken()
  const headers = new Headers(init.headers || {})
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`)
  }
  // Un FormData lleva su propio Content-Type multipart con boundary: forzar JSON lo rompe.
  const esFormData = typeof FormData !== 'undefined' && init.body instanceof FormData
  if (init.body && !esFormData && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  return fetch(input, { ...init, headers })
}

export default apiFetch
